export default {
  title: 'Configuración de propinas',
  form: {
    has_tips: {
      label: 'Permitir propinas',
    },
    default_tip_percentage: {
      label: 'Porcentaje de propina preseleccionado',
      tooltip: 'Este es el porcentaje que se preseleccionará para el cliente cuando llegue a la pantalla de pago',
    },
    is_tip_hidden_on_receipt: {
      label: 'Propinas no visibles en recibos',
      tooltip:
        'Cuando está activado, oculta las propinas en los recibos impresos y en la ventana de información del pedido',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Cambios guardados',
  },
};
